
import { createForm } from '../../../factories'

export default createForm(['role', 'active'])



// WEBPACK FOOTER //
// ./src/store/modules/members/forms/update.js